import { Monitor, Moon, Sun } from 'lucide-react';
import { Button } from '@/kit';
import { useTheme } from '@/hooks/useTheme';

/** The icon for each preference (the bar's button and, below 768, the account menu's entry). */
export const THEME_ICON = { dark: Moon, light: Sun, system: Monitor } as const;

export const THEME_LABEL = {
  dark: 'Dark theme — switch to light',
  light: 'Light theme — follow system next',
  system: 'Following system theme — switch to dark',
} as const;

/** The L0 bar's theme button: one click steps Dark → Light → System (the full switch is on /help/app-standard). */
export function ThemeToggle() {
  const { preference, toggleTheme } = useTheme();
  const Icon = THEME_ICON[preference];
  return (
    <Button icon onClick={toggleTheme} aria-label={THEME_LABEL[preference]} title={THEME_LABEL[preference]}>
      <Icon aria-hidden />
    </Button>
  );
}
